import { render, staticRenderFns } from "./Programmer.vue?vue&type=template&id=30151a45&scoped=true"
import script from "./Programmer.vue?vue&type=script&lang=js"
export * from "./Programmer.vue?vue&type=script&lang=js"
import style0 from "./Programmer.vue?vue&type=style&index=0&id=30151a45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30151a45",
  null
  
)

export default component.exports